/**
 * CalendarProvider - Combined Context Provider
 * Wraps all calendar contexts in the correct order
 * Use this as the main provider in your app
 */

import React from 'react';
import { CalendarStateProvider } from './CalendarStateContext';
import { CalendarActionsProvider } from './CalendarActionsContext';
import { CalendarUIProvider } from './CalendarUIContext';

/**
 * Combined Calendar Provider
 * Provides all calendar contexts to child components
 * Order matters: State -> Actions -> UI
 */
export const CalendarProvider = ({ children, ...props }) => {
  return (
    <CalendarStateProvider {...props}>
      <CalendarActionsProvider>
        <CalendarUIProvider>{children}</CalendarUIProvider>
      </CalendarActionsProvider>
    </CalendarStateProvider>
  );
};

export default CalendarProvider;
